import { FC, ImgHTMLAttributes } from "react";
import GemIcon from "./assets/gem_1x.webp";
import GemIcon2x from "./assets/gem_2x.webp";
import GemIcon3x from "./assets/gem_3x.webp";
import GZCoinIcon from "../../../assets/icon/gamezone_coin/gamezone_coin_1x.webp";
import GZCoinIcon2x from "../../../assets/icon/gamezone_coin/gamezone_coin_2x.webp";
import GZCoinIcon3x from "../../../assets/icon/gamezone_coin/gamezone_coin_3x.webp";

interface IChipProps {
  type: "gem" | "gz-token";
  size?: number;
}

export const Chip: FC<ImgHTMLAttributes<HTMLImageElement> & IChipProps> = (
  props,
) => {
  const { type = "gz-token", size, ...otherProps } = props;
  const shipSrc =
    type === "gz-token"
      ? `${GZCoinIcon} 1x, ${GZCoinIcon2x} 2x, ${GZCoinIcon3x} 3x`
      : `${GemIcon} 1x, ${GemIcon2x} 2x, ${GemIcon3x} 3x`;

  return (
    <img
      {...otherProps}
      width={size}
      height={size}
      srcSet={shipSrc}
      alt={type}
    />
  );
};
